export class Level {
    name:string=""
    shortName=""
    server_education_system_id=0
    server_country_id=0
    ordinalNumber=0
    id=0
    description=""

    formData(){
        let body = new URLSearchParams();
        body.set('name', this.name);
        body.set('server_education_system_id', this.server_education_system_id.toString());
        body.set('server_country_id', this.server_country_id.toString());

        body.set('shortName', this.shortName);
        body.set('description',this.description)
        body.set('id', this.id.toString());
        body.set('ordinalNumber', this.ordinalNumber.toString())
        return body.toString()
      }

}
